<template>
  <EInstantAnswer
    class="computation"
    data-test-id="computation"
    :feedback-link="{
      ticketSubject: `Search - ${trackID}`,
      widgetType: `${trackID}_${widgetType}`,
    }"
    :sr-title="srTitle"
    :powered-by-ecosia="calculator"
    :trees="calculator && !isTabletUp"
  >
    <template v-if="plain" #context>
      {{ $t('web.widgets.computation.context') }}
    </template>
    <template v-if="plain" #title>
      <output class="computation__output" data-test-id="computation-output">
        {{ expression }} = {{ value }}
      </output>
    </template>
    <div v-if="loading" class="computation__loading">
      <EIcon icon="spinner" />
    </div>
    <ECalculator
      v-show="calculator"
      :initial-expression="expression"
      @initial-parse="onInitialParse"
    />
  </EInstantAnswer>
</template>

<script>
import screen from '~~/common/vue/mixins/screen';
import EIcon from '~~/common/vue/components/icon';

import EInstantAnswer from '~/components/instant-answers/base';
import { trackImpression, PAGE_SERP, TYPE_RICH, TYPE_WIDGET } from '~~/search/common/js/client/analytics/rich-content';
import ECalculator from './calculator';

const LOADING = 'loading';
const PLAIN = 'plain';
const CALCULATOR = 'calculator';

export default {
  name: 'EComputationEntrypoint',
  components: {
    ECalculator,
    EInstantAnswer,
    EIcon,
  },
  mixins: [screen],
  props: {
    expression: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    mode: LOADING,
  }),
  computed: {
    loading() {
      return this.mode === LOADING;
    },
    plain() {
      return this.mode === PLAIN;
    },
    calculator() {
      return this.mode === CALCULATOR;
    },
    trackID() {
      switch (this.mode) {
        case CALCULATOR:
          return 'calculator';
        case PLAIN:
        default:
          return 'computation';
      }
    },
    widgetType() {
      switch (this.mode) {
        case CALCULATOR:
          return TYPE_WIDGET;
        case PLAIN:
        default:
          return TYPE_RICH;
      }
    },
    srTitle() {
      switch (this.mode) {
        case CALCULATOR:
          return this.$t('web.widgets.calculator.title');
        case PLAIN:
        default:
          return this.$t('common.search.widgets.computation.title');
      }
    },
  },
  methods: {
    onInitialParse({ success }) {
      if (success) {
        this.mode = CALCULATOR;
      } else {
        this.mode = PLAIN;
      }

      trackImpression({
        name: this.trackID,
        page: PAGE_SERP,
        type: this.widgetType,
        once: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.computation__loading {
  display: flex;
  justify-content: center;
  margin: $space-l 0;
}
</style>
